export default "__VITE_ASSET__R3HMTQ0L__"